export default __webpack_public_path__ + "static/media/icons-menu-vertical.4f2865a6.svg";